import { uploadImages } from "@/pages/api";
import React from "react";
import toast from "react-hot-toast";
import { useState } from "react";
import Spinner from "../SpinnerComponent/Spinners";
const InputFileComponent = ({ data, onInputChange }) => {
  const [imageLink, setImageLink] = React.useState([]);
  const { inputKey, placeholder, required, label } = data;
  const [isLoading, setIsLoading] = useState(false);

  const onFileSelect = async (e) => {
    setIsLoading(true);
    if (e.target.files.length > 0) {
      const fileUploadResponse = await uploadImages(e.target.files);
      if (fileUploadResponse.status === 200) {
        setIsLoading(false);
        if (Array.isArray(fileUploadResponse.data)) {
          const event = {
            target: {
              name: inputKey,
              value: fileUploadResponse.data,
            },
          };
          setImageLink(imageLink);
          onInputChange(event);
          toast.success("File uploaded successfully");
        } else {
          toast.error(fileUploadResponse.data?.message || "");
        }
      } else {
        toast.error("File upload failed");
      }
    } else {
      toast.error("No file selected");
    }
  };

  return (
    <fieldset className="border border-light-grey-color w-full h-12 rounded-md mb-7">
      <legend className="mx-3 px-1 text-xs">
        {label} {required ? "*" : ""}
      </legend>
      <div className="flex flex-row justify-start text-sm text-Default items-center px-3">
        <input
          placeholder={placeholder}
          type="file"
          id="file"
          className="flex flex-row-reverse gap-2 mx-0 w-full border-0 placeholder:text-[#47556980] bg-transparent focus:outline-none placeholder:text-sm rounded-md px-2"
          name={inputKey}
          onChange={onFileSelect}
          disabled={isLoading} // Disable input when loading
        />
        {isLoading && (
          <div className="ml-3">
            <Spinner loading={isLoading} />{" "}
            {/* Display spinner without removing the input */}
          </div>
        )}
      </div>
    </fieldset>
  );
};

export default InputFileComponent;
